import React from 'react';

import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyIncentiveCooldownMessage } from 'pages/loyalty/loyalty-incentives-components/loyalty-incentive-cooldown-message';
import LoyaltyRewards from 'pages/loyalty/loyalty-rewards/loyalty-rewards';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';

function Rewards() {
  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyRewards />
      <LoyaltyIncentiveCooldownMessage incentiveType={LoyaltyPromotionType.REWARD} />
    </>
  );
}
export default React.memo(Rewards);
